import { i as e, o as t, s as n, t as r } from "./dist-C5MhUQHh.js";
import { t as i } from "./index.js";
import { a, d as o, i as s, n as c, o as l, s as u, u as d, y as f } from "./store-DiJDr6QX.js";
import { useApolloClient as p } from "@apollo/client";
import m, { useCallback as h, useEffect as g, useMemo as _, useRef as v, useState as y } from "react";
//#region ../delivery-common/src/hooks/useDeliveryLanguages.ts
function b({ selectedLanguageId: e, onCompleted: t, fetchPolicy: n = "cache-first" } = {}) {
	let { data: r, ...i } = f({
		fetchPolicy: n,
		onCompleted: t
	});
	return {
		...i,
		data: x(r, e)
	};
}
function x(e, t) {
	if (!e?.organisationSettings) return;
	let n = e.organisationSettings.enabledLanguages.find((e) => e.languageId === t) || e.organisationSettings.defaultLanguage;
	return {
		...e.organisationSettings,
		selectedLanguage: n
	};
}
//#endregion
//#region src/hooks/useSelectedLanguage.ts
function S() {
	let [t, n] = r("langId", e);
	return {
		selectedLanguageId: t,
		setSelectedLanguageId: n
	};
}
//#endregion
//#region ../../../node_modules/valtio/node_modules/use-sync-external-store/cjs/use-sync-external-store-shim.production.min.js
var C = /* @__PURE__ */ t(((e) => {
	var t = i();
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, a = t.useState, o = t.useEffect, s = t.useLayoutEffect, c = t.useDebugValue;
	function l(e, t) {
		var n = t(), r = a({ inst: {
			value: n,
			getSnapshot: t
		} }), i = r[0].inst, l = r[1];
		return s(function() {
			i.value = n, i.getSnapshot = t, u(i) && l({ inst: i });
		}, [
			e,
			n,
			t
		]), o(function() {
			return u(i) && l({ inst: i }), e(function() {
				u(i) && l({ inst: i });
			});
		}, [e]), c(n), n;
	}
	function u(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function d(e, t) {
		return t();
	}
	var f = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? d : l;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? f : t.useSyncExternalStore;
})), w = /* @__PURE__ */ t(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(/* @__PURE__ */ Error());
		var t = i(), n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
		function r(e) {
			a("error", e, [...arguments].slice(1));
		}
		function a(e, t, r) {
			var i = n.ReactDebugCurrentFrame.getStackAddendum();
			i !== "" && (t += "%s", r = r.concat([i]));
			var a = r.map(function(e) {
				return String(e);
			});
			a.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, a);
		}
		function o(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		var s = typeof Object.is == "function" ? Object.is : o, c = t.useState, l = t.useEffect, u = t.useLayoutEffect, d = t.useDebugValue, f = !1, p = !1;
		function m(e, n, i) {
			f || t.startTransition !== void 0 && (f = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
			var a = n();
			p || s(a, n()) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), p = !0);
			var o = c({ inst: {
				value: a,
				getSnapshot: n
			} }), m = o[0].inst, g = o[1];
			return u(function() {
				m.value = a, m.getSnapshot = n, h(m) && g({ inst: m });
			}, [
				e,
				a,
				n
			]), l(function() {
				return h(m) && g({ inst: m }), e(function() {
					h(m) && g({ inst: m });
				});
			}, [e]), d(a), a;
		}
		function h(e) {
			var t = e.getSnapshot, n = e.value;
			try {
				return !s(n, t());
			} catch {
				return !0;
			}
		}
		function g(e, t, n) {
			return t();
		}
		var _ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? m : g;
		e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? _ : t.useSyncExternalStore, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(/* @__PURE__ */ Error());
	})();
})), T = /* @__PURE__ */ n((/* @__PURE__ */ t(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = C() : t.exports = w();
})))(), 1), { use: E } = m, { useSyncExternalStore: D } = T.default, O = /* @__PURE__ */ new WeakMap();
function k(e, t) {
	let n = t?.sync, r = v(), i = v(), o = !0, c = D(h((t) => {
		let r = a(e, t, n);
		return t(), r;
	}, [e, n]), () => {
		let t = s(e, E);
		try {
			if (!o && r.current && i.current && !u(r.current, t, i.current, /* @__PURE__ */ new WeakMap())) return r.current;
		} catch {}
		return t;
	}, () => s(e, E));
	o = !1;
	let d = /* @__PURE__ */ new WeakMap();
	return g(() => {
		r.current = c, i.current = d;
	}), l(c, d, _(() => /* @__PURE__ */ new WeakMap(), []), O);
}
//#endregion
//#region src/hooks/useCategoryOpen/useCategoryOpen.ts
function A(e) {
	let { [e]: t } = k(c), n = h((t) => c[e] = t, [e]);
	return {
		isCategoryOpen: !!t,
		setCategoryOpen: n
	};
}
function j() {
	let { cache: e } = p();
	return { openToArticle: h((t) => {
		M(e, t);
	}, [e]) };
}
function M(e, t) {
	let n = e.readFragment({
		fragment: d,
		id: e.identify({
			__typename: "KbArticle",
			id: t
		})
	});
	n?.parentCategory && (c[n.parentCategory.id] = !0, N(e, n.parentCategory.id));
}
function N(e, t) {
	let n = e.readFragment({
		fragment: o,
		id: e.identify({
			__typename: "KbCategory",
			id: t
		})
	});
	n?.parentCategory && (c[n.parentCategory.id] = !0, N(e, n.parentCategory.id));
}
//#endregion
//#region ../delivery-common/src/hooks/useDebounce.ts
function P(e, t) {
	let [n, r] = y(e);
	return g(() => {
		let n = setTimeout(() => r(e), t);
		return () => {
			clearTimeout(n);
		};
	}, [e, t]), n;
}
//#endregion
//#region src/hooks/useKbSearch.ts
function F() {
	let [t, n] = r("q", e), [i, a] = y(t || ""), o = P(i, 500);
	g(() => {
		n(o.length > 0 ? o : null);
	}, [o, n]);
	let s = h(() => {
		n(null), a("");
	}, [n]);
	return {
		urlSearch: t || "",
		searchValue: i,
		setSearchValue: a,
		clearSearch: s
	};
}
//#endregion
export { S as a, k as i, A as n, b as o, j as r, F as t };

//# sourceMappingURL=useKbSearch-CnfBTgOS.js.map